export const POLICIES_PAGE_CONTENT = {
  en: {
    hero: {
      eyebrow: "Wayli legal information",
      title: "Legal Information",
      description:
        "This page combines the legal and operational texts provided for Wayli, including terms, privacy, cancellation rules, safety, minor consent, and handover documents.",
      navLabel: "Legal navigation",
    },
    highlights: [
      {
        accent: "reef",
        iconKey: "book",
        title: "Document-based content",
        description:
          "The legal sections below follow the provided business documents rather than summary marketing copy.",
      },
      {
        accent: "dawn",
        iconKey: "shield",
        title: "German + English",
        description:
          "The German version is authoritative. The English version is an automatic translation for convenience only; in case of discrepancies, the German version prevails.",
      },
      {
        accent: "lunar",
        iconKey: "refresh",
        title: "Rental workflow coverage",
        description:
          "The page now also covers minor consent and rental handover / protocol content used in operations.",
      },
    ],
    sections: [
      {
        id: "impressum",
        iconKey: "info",
        accent: "reef",
        title: "Impressum",
        eyebrow: "Information according to the provided notice",
        blocks: [
          {
            type: "paragraph",
            text: "Information according to § 5 ECG, § 14 UGB, § 63 GewO and § 25 Mediengesetz",
          },
          {
            type: "meta",
            items: [
              { label: "Business Name", value: "Wayli" },
              { label: "Owner", value: "Andrii Lozovyi" },
              { label: "Business Form", value: "Einzelunternehmen (Sole Proprietorship)" },
              { label: "Business Address", value: "Dresdnerstrasse, 1200, Vienna, Austria" },
              { label: "Contact", value: "Email: wayli@wayli.eu" },
              { label: "ERJ", value: "9110038973861" },
              {
                label: "Business Activity",
                value:
                  "Rental of sports and leisure equipment, in particular stand-up paddle boards and kayaks.",
              },
              { label: "Gewerbebehörde", value: "Magistrat der Stadt Wien" },
              {
                label: "Applicable Legal Regulations",
                value: "Gewerbeordnung (GewO) Available at: www.ris.bka.gv.at",
              },
              { label: "Supervisory Authority", value: "Magistrat der Stadt Wien" },
              { label: "Responsible for Website Content", value: "Andrii Lozovyi" },
              {
                label: "Online Dispute Resolution",
                value:
                  "https://ec.europa.eu/consumers/odr/ We are not obliged or willing to participate in dispute resolution proceedings before a consumer arbitration board.",
              },
            ],
          },
        ],
      },
      {
        id: "terms",
        iconKey: "terms",
        accent: "dawn",
        title: "General Terms and Conditions (AGB)",
        eyebrow: "General Terms and Conditions (AGB) – Wayli",
        blocks: [
          { type: "heading", text: "1. Scope of Application" },
          {
            type: "paragraph",
            text:
              "These General Terms and Conditions (“Terms”) apply to all bookings, rentals, and services provided by Wayli (hereinafter “Operator”) related to the rental of stand-up paddle boards, kayaks, and related equipment.",
          },
          {
            type: "paragraph",
            text:
              "These Terms apply to all bookings made via the website, booking system, email, or other communication channels. By making a booking or using the services, the customer agrees to these Terms.",
          },
          { type: "heading", text: "2. Contract Conclusion" },
          {
            type: "paragraph",
            text:
              "A contract between the Operator and the customer is concluded when the customer completes a booking and receives a booking confirmation via email or the booking system.",
          },
          {
            type: "paragraph",
            text:
              "The booking confirmation contains the essential details of the rental and constitutes the rental agreement.",
          },
          { type: "heading", text: "3. Services" },
          {
            type: "paragraph",
            text:
              "The Operator rents stand-up paddle boards, kayaks, paddles, safety equipment, and related accessories for recreational use on designated water areas.",
          },
          {
            type: "paragraph",
            text:
              "The Operator does not provide supervision or guided tours unless explicitly agreed. The customer uses the equipment independently and at their own responsibility.",
          },
          { type: "heading", text: "4. Prices and Payment" },
          {
            type: "paragraph",
            text:
              "All prices are stated in Euro. Payment must be made through the available payment methods at the time of booking.",
          },
          { type: "paragraph", text: "The booking is valid only after successful payment confirmation." },
          {
            type: "paragraph",
            text: "If applicable, prices include statutory VAT unless otherwise stated.",
          },
          { type: "heading", text: "5. Rental Period" },
          {
            type: "paragraph",
            text: "The rental period begins at the agreed booking time and ends at the agreed return time.",
          },
          {
            type: "paragraph",
            text:
              "If the equipment is returned late, the Operator may charge additional fees according to the price list. If late return prevents further rentals or causes operational disruption, compensation for loss of use may be charged.",
          },
          { type: "heading", text: "6. Obligations of the Customer" },
          { type: "paragraph", text: "The customer agrees:" },
          {
            type: "list",
            items: [
              "to use the equipment carefully and properly",
              "to follow all safety instructions and local regulations",
              "not to use the equipment under the influence of alcohol or drugs",
              "to use the equipment only in designated areas",
              "not to transfer the equipment to third parties",
              "to return the equipment on time and in proper condition",
              "to report any damage or malfunction immediately",
            ],
          },
          {
            type: "paragraph",
            text:
              "The customer confirms that they are physically capable of using the equipment, can swim, and understand the risks associated with water sports.",
          },
          { type: "heading", text: "7. Safety and Usage Rules" },
          {
            type: "paragraph",
            text:
              "The customer must check weather and water conditions before use and must stop using the equipment immediately in case of dangerous conditions such as storms, strong wind, or other hazards.",
          },
          {
            type: "paragraph",
            text:
              "The customer must comply with all local water regulations and safety rules. The Operator may prohibit the use of equipment if conditions are unsafe.",
          },
          { type: "heading", text: "8. Equipment Condition, Damage, and Loss" },
          {
            type: "paragraph",
            text: "The customer must inspect the equipment before use and report any visible damage immediately.",
          },
          {
            type: "paragraph",
            text:
              "The customer is liable for any damage, loss, or theft of equipment occurring during the rental period, unless the damage is due to normal wear or a defect that existed before the rental.",
          },
          { type: "paragraph", text: "Repair or replacement costs may be charged to the customer." },
          { type: "heading", text: "9. Late Return" },
          {
            type: "paragraph",
            text:
              "If the equipment is returned late, the Operator may charge late fees according to the price list. Additional damages may be charged if the late return causes loss of bookings or operational disruption.",
          },
          { type: "heading", text: "10. Personal Belongings" },
          {
            type: "paragraph",
            text:
              "The Operator is not liable for loss, theft, or damage of personal belongings. Waterproof bags or storage compartments are provided only as a convenience and are not guaranteed to be fully waterproof.",
          },
          { type: "heading", text: "11. Liability" },
          { type: "paragraph", text: "Use of the equipment is at the customer’s own risk." },
          {
            type: "paragraph",
            text:
              "The Operator shall be liable only for damages caused by intent or gross negligence, in accordance with applicable law. Liability for personal injury, damage to health, or claims under mandatory statutory provisions remains unaffected.",
          },
          {
            type: "paragraph",
            text:
              "The Operator shall not be liable for damages resulting from improper use of equipment, weather conditions, water conditions, third-party actions, or force majeure events.",
          },
          { type: "heading", text: "12. Cancellation and Withdrawal" },
          {
            type: "paragraph",
            text: "Bookings may be cancelled up to 24 hours before the rental start time unless otherwise stated.",
          },
          {
            type: "paragraph",
            text: "Cancellations made less than 24 hours before the rental may not be refunded.",
          },
          {
            type: "paragraph",
            text:
              "In case of unsafe weather or operational issues, the Operator may cancel bookings and offer rescheduling or refund.",
          },
          {
            type: "paragraph",
            text:
              "If statutory consumer withdrawal rights apply, customers will be informed separately during the booking process.",
          },
          { type: "heading", text: "13. No-Show" },
          {
            type: "paragraph",
            text:
              "If the customer does not appear at the booked time and does not cancel the booking, the Operator may charge the full booking amount.",
          },
          { type: "heading", text: "14. Force Majeure" },
          {
            type: "paragraph",
            text:
              "The Operator shall not be liable for failure to perform services due to events beyond its control, including severe weather conditions, natural events, accidents, government restrictions, or other force majeure events.",
          },
          { type: "heading", text: "15. Group Bookings" },
          {
            type: "paragraph",
            text:
              "For group bookings, the person making the booking is responsible for all participants and liable for damages caused by any participant included in the booking.",
          },
          { type: "heading", text: "16. Minimum Age" },
          {
            type: "paragraph",
            text:
              "Equipment may only be rented by persons who are legally capable of entering into contracts. Minors may only use equipment with the consent and responsibility of a legal guardian.",
          },
          { type: "heading", text: "17. Data Protection" },
          {
            type: "paragraph",
            text:
              "Personal data is processed in accordance with the Privacy Policy available on the website and in compliance with applicable data protection laws including GDPR.",
          },
          { type: "heading", text: "18. Applicable Law and Jurisdiction" },
          {
            type: "paragraph",
            text:
              "Austrian law applies to all contracts and legal relationships between the Operator and the customer.",
          },
          {
            type: "paragraph",
            text:
              "The place of jurisdiction is Vienna, Austria, unless mandatory consumer protection law provides otherwise.",
          },
          { type: "heading", text: "19. Severability Clause" },
          {
            type: "paragraph",
            text:
              "If any provision of these Terms is invalid or unenforceable, the remaining provisions shall remain in full force and effect.",
          },
          { type: "heading", text: "20. Changes to Terms" },
          {
            type: "paragraph",
            text:
              "The Operator reserves the right to amend these Terms. The version valid at the time of booking shall apply.",
          },
        ],
      },
      {
        id: "cancellation",
        iconKey: "refresh",
        accent: "coral",
        title: "Cancellation, Withdrawal and Refund Policy",
        eyebrow: "Cancellation, Withdrawal and Refund Policy – Wayli",
        blocks: [
          { type: "heading", text: "1. Scope" },
          {
            type: "paragraph",
            text:
              "This Cancellation, Withdrawal and Refund Policy applies to all bookings made with Wayli for the rental of stand-up paddle boards, kayaks, and related equipment via the website or booking system.",
          },
          { type: "paragraph", text: "By making a booking, the customer agrees to this Cancellation Policy." },
          { type: "heading", text: "2. Cancellation by Customer" },
          {
            type: "paragraph",
            text: "Customers may cancel or reschedule their booking under the following conditions:",
          },
          {
            type: "list",
            items: [
              "Cancellation up to 1 hour before the rental start time: the customer may choose between rescheduling or receiving a voucher for future bookings.",
              "Cancellation less than 1 hour before the rental start time: no refund.",
              "If the customer does not appear at the booked time (“no-show”), the full booking amount may be charged.",
              "The Operator may, at its own discretion, allow rescheduling or vouchers in individual cases.",
            ],
          },
          {
            type: "paragraph",
            text: "Cancellation requests must be made via the booking system or by contacting the Operator via email.",
          },
          { type: "heading", text: "3. Cancellation by Operator" },
          {
            type: "paragraph",
            text: "The Operator reserves the right to cancel bookings in the following cases:",
          },
          {
            type: "list",
            items: [
              "Unsafe weather conditions (strong wind, storms, heavy rain, unsafe water conditions)",
              "Safety risks",
              "Equipment damage or technical issues",
              "Operational issues",
              "Force majeure events",
              "Government restrictions or legal requirements",
            ],
          },
          { type: "paragraph", text: "In such cases, customers may choose between:" },
          {
            type: "list",
            items: [
              "rescheduling the booking,",
              "receiving a voucher, or",
              "receiving a refund via the original payment method.",
            ],
          },
          { type: "heading", text: "4. Vouchers" },
          { type: "paragraph", text: "Vouchers issued due to cancellations or goodwill refunds:" },
          {
            type: "list",
            items: [
              "can be used for future bookings on the website,",
              "are non-transferable unless otherwise stated,",
              "cannot be exchanged for cash unless required by law,",
              "may have a validity period stated on the voucher.",
            ],
          },
          { type: "heading", text: "5. Refunds" },
          {
            type: "paragraph",
            text:
              "Refunds are generally issued via vouchers unless a refund to the original payment method is required by law or the Operator cancels the booking.",
          },
          {
            type: "paragraph",
            text:
              "Refund processing time depends on the payment provider and may take several business days.",
          },
          { type: "heading", text: "6. Statutory Withdrawal Right (EU Consumer Law)" },
          {
            type: "paragraph",
            text:
              "If a booking is made online, consumers generally have a statutory right of withdrawal within 14 days.",
          },
          {
            type: "paragraph",
            text:
              "However, according to Article 16 of Directive 2011/83/EU, the right of withdrawal does not apply to services related to leisure activities if the contract provides for a specific date or period of performance.",
          },
          {
            type: "paragraph",
            text:
              "Since the services offered by Wayli relate to leisure activities booked for a specific date and time, the statutory withdrawal right does not apply once the booking has been confirmed.",
          },
          {
            type: "paragraph",
            text:
              "By completing a booking, the customer acknowledges that the service is provided on a specific date and time and agrees that the statutory withdrawal right does not apply.",
          },
          { type: "heading", text: "7. Force Majeure" },
          {
            type: "paragraph",
            text:
              "In case of events beyond the Operator’s control, including severe weather, natural events, accidents, equipment failure, government restrictions, or other force majeure events, bookings may be cancelled or rescheduled without liability for additional damages.",
          },
          { type: "heading", text: "8. Changes to Bookings" },
          {
            type: "paragraph",
            text:
              "Customers may request changes to bookings such as rescheduling, subject to availability and at the Operator’s discretion.",
          },
          { type: "heading", text: "9. Contact for Cancellations" },
          {
            type: "paragraph",
            text: "For cancellations, rescheduling, or refund requests, please contact: wayli@wayli.eu",
          },
        ],
      },
      {
        id: "privacy",
        iconKey: "privacy",
        accent: "mint",
        title: "Privacy Policy",
        eyebrow: "Privacy Policy (Datenschutzerklärung) – Wayli",
        blocks: [
          {
            type: "paragraph",
            text:
              "This Privacy Policy informs you about the nature, scope, and purpose of the processing of personal data when using our website and services.",
          },
          { type: "heading", text: "1. Data Controller" },
          {
            type: "paragraph",
            text:
              "The Wayli controller responsible for data processing is: Andrii Lozovyi, Dresdnerstrasse 62, 1200, Vienna, Austria. Email: wayli@wayli.eu",
          },
          { type: "heading", text: "2. Collection and Processing of Personal Data" },
          {
            type: "paragraph",
            text:
              "We process personal data only insofar as this is necessary to provide a functional website, our booking system, and our services.",
          },
          {
            type: "paragraph",
            text:
              "Personal data may include in particular name, email address, phone number, booking information, customer account data, communication data, IP address, and technical usage data.",
          },
          { type: "heading", text: "3. Purpose of Processing" },
          {
            type: "paragraph",
            text:
              "Personal data is processed for the purpose of operating the website, managing bookings and rentals, processing payments, communicating with customers, sending booking confirmations and service notifications, operating customer accounts, ensuring system security, and fulfilling legal obligations.",
          },
          { type: "heading", text: "4. Legal Basis for Processing" },
          {
            type: "paragraph",
            text:
              "Processing of personal data is based on the following legal bases under Article 6 GDPR:",
          },
          {
            type: "list",
            items: [
              "Performance of a contract (Art. 6(1)(b) GDPR)",
              "Legal obligations (Art. 6(1)(c) GDPR)",
              "Legitimate interests such as website security and system operation (Art. 6(1)(f) GDPR)",
              "Consent where required (Art. 6(1)(a) GDPR)",
            ],
          },
          { type: "heading", text: "5. Payment Processing" },
          {
            type: "paragraph",
            text:
              "Payments are processed via Stripe Payments Europe Ltd. Stripe processes personal and payment data necessary for payment processing. We do not store full credit card details on our servers.",
          },
          { type: "paragraph", text: "Stripe Privacy Policy: https://stripe.com/privacy" },
          { type: "heading", text: "6. Hosting" },
          {
            type: "paragraph",
            text:
              "Our website and booking system are hosted on Amazon Web Services (AWS). AWS processes technical data and server log files necessary for the operation and security of the website.",
          },
          { type: "paragraph", text: "AWS Privacy Policy: https://aws.amazon.com/privacy/" },
          { type: "heading", text: "7. Email and SMS Communication" },
          {
            type: "paragraph",
            text:
              "We use external service providers for sending emails and SMS notifications related to bookings and customer communication. For this purpose, personal data such as email address and phone number may be processed.",
          },
          { type: "heading", text: "8. Data Processors" },
          {
            type: "paragraph",
            text:
              "We use external service providers (processors) for hosting, payment processing, email services, and SMS services. These service providers process personal data on our behalf based on data processing agreements in accordance with Article 28 GDPR.",
          },
          { type: "heading", text: "9. Data Transfer Outside the European Union" },
          {
            type: "paragraph",
            text:
              "Some service providers may process data outside the European Union. In such cases, data transfers are carried out on the basis of EU Standard Contractual Clauses or other appropriate safeguards in accordance with GDPR.",
          },
          { type: "heading", text: "10. Cookies" },
          {
            type: "paragraph",
            text:
              "Our website uses cookies necessary for website functionality, login sessions, booking processes, and security. Optional cookies such as analytics cookies will only be used with user consent.",
          },
          { type: "heading", text: "11. Server Log Files" },
          {
            type: "paragraph",
            text:
              "The hosting provider automatically collects and stores information in server log files, including IP address, browser type, operating system, referrer URL, and time of the request. This data is used for system security and technical monitoring.",
          },
          { type: "heading", text: "12. Data Recipients" },
          {
            type: "paragraph",
            text:
              "Personal data may be shared with service providers such as hosting providers, payment providers, email and SMS providers, and tax authorities where required by law. Personal data is not sold to third parties.",
          },
          { type: "heading", text: "13. Data Retention" },
          {
            type: "paragraph",
            text:
              "Personal data is stored only as long as necessary for the purposes described above or as required by legal obligations. Booking and invoice data are stored for seven years in accordance with tax law requirements.",
          },
          { type: "heading", text: "14. Data Security" },
          {
            type: "paragraph",
            text:
              "We implement appropriate technical and organizational measures to protect personal data against loss, misuse, unauthorized access, disclosure, or alteration.",
          },
          { type: "heading", text: "15. Rights of Data Subjects" },
          {
            type: "paragraph",
            text:
              "Under GDPR, users have the right to access, rectify, delete, restrict processing, and transfer their personal data, as well as the right to withdraw consent and lodge a complaint with the Austrian Data Protection Authority.",
          },
          {
            type: "paragraph",
            text:
              "Austrian Data Protection Authority Barichgasse 40-42 1030 Vienna https://www.dsb.gv.at/",
          },
          { type: "heading", text: "16. Contact" },
          { type: "paragraph", text: "For privacy-related requests, please contact: wayli@wayli.eu" },
          { type: "heading", text: "17. Changes to this Privacy Policy" },
          {
            type: "paragraph",
            text:
              "We reserve the right to update this Privacy Policy to comply with legal requirements or changes to our services. The current version is always available on our website.",
          },
        ],
      },
      {
        id: "liability",
        iconKey: "risk",
        accent: "lunar",
        title: "Liability Waiver and Risk Acknowledgement",
        eyebrow: "Liability Waiver and Risk Acknowledgement – Wayli",
        blocks: [
          { type: "heading", text: "1. Acknowledgement of Risk" },
          {
            type: "paragraph",
            text:
              "The customer acknowledges that stand-up paddling, kayaking, and water sports activities involve inherent risks, including but not limited to:",
          },
          {
            type: "list",
            items: [
              "falling into water,",
              "drowning,",
              "collisions with other persons, boats, or objects,",
              "injuries caused by equipment,",
              "weather-related hazards,",
              "water currents, waves, wind, or temperature,",
              "loss or damage of personal belongings,",
              "accidents during transport, handling, launching, or returning equipment.",
            ],
          },
          {
            type: "paragraph",
            text:
              "Participation in these activities takes place voluntarily and at the customer's own risk.",
          },
          { type: "heading", text: "2. Physical Fitness and Swimming Ability" },
          {
            type: "paragraph",
            text:
              "Use of the equipment requires that the following conditions be met by the customer:",
          },
          {
            type: "list",
            items: [
              "they are physically and mentally capable of participating in water sports,",
              "they are able to swim sufficiently to ensure their own safety,",
              "they are not under the influence of alcohol, drugs, or medication that may impair their ability to safely use the equipment,",
              "they will comply with all safety instructions and local regulations.",
            ],
          },
          {
            type: "paragraph",
            text:
              "The equipment may not be used if weather or water conditions are unsafe.",
          },
          { type: "heading", text: "3. Proper Use of Equipment" },
          {
            type: "paragraph",
            text: "The following obligations apply to the customer:",
          },
          {
            type: "list",
            items: [
              "to use the equipment carefully and only for its intended purpose,",
              "not to use the equipment outside designated areas,",
              "not to transfer the equipment to third parties,",
              "to follow all safety instructions,",
              "to return the equipment in proper condition,",
              "to report any damage or incidents immediately.",
            ],
          },
          {
            type: "paragraph",
            text:
              "The customer is responsible for any damage, loss, or theft of equipment occurring during the rental period, unless caused by material defects or normal wear and tear.",
          },
          { type: "heading", text: "4. Personal Belongings" },
          {
            type: "paragraph",
            text:
              "The Operator is not liable for loss, theft, or damage of personal belongings, including mobile phones, wallets, clothing, or other valuables.",
          },
          {
            type: "paragraph",
            text:
              "Waterproof bags or storage compartments provided are not guaranteed to be fully waterproof.",
          },
          { type: "heading", text: "5. Limitation of Liability" },
          {
            type: "paragraph",
            text: "To the extent permitted by applicable law, the Operator shall not be liable for:",
          },
          {
            type: "list",
            items: [
              "accidents or injuries occurring during use of equipment,",
              "damages caused by weather conditions, water conditions, or third parties,",
              "improper use of equipment,",
              "loss or damage of personal belongings,",
              "indirect damages, loss of profit, or consequential damages.",
            ],
          },
          {
            type: "paragraph",
            text:
              "This limitation of liability does not apply in cases of intent or gross negligence by the Operator or in cases of injury to life, body, or health where liability cannot be excluded by law.",
          },
          { type: "heading", text: "6. Customer Liability" },
          {
            type: "paragraph",
            text:
              "The customer is liable for all damages caused to equipment, other persons, or property through improper use, negligence, or violation of rules.",
          },
          {
            type: "paragraph",
            text:
              "The customer is required to reimburse the Operator for repair, replacement, cleaning, recovery, or rescue costs resulting from the customer’s actions.",
          },
          { type: "heading", text: "7. Group Bookings" },
          {
            type: "paragraph",
            text:
              "For group bookings, the person making the booking is responsible for all participants and liable for damages caused by any participant.",
          },
          { type: "heading", text: "8. Compliance with Laws and Regulations" },
          {
            type: "paragraph",
            text:
              "The customer is required to comply with all applicable laws, water regulations, navigation rules, and safety regulations.",
          },
          {
            type: "paragraph",
            text:
              "Any fines, penalties, or damages resulting from violations are the responsibility of the customer.",
          },
          { type: "heading", text: "9. Acceptance of Liability Waiver" },
          {
            type: "paragraph",
            text:
              "By making a booking, using the equipment, or accepting the rental equipment, the following is acknowledged by the customer:",
          },
          {
            type: "list",
            items: [
              "the customer has read this Liability Waiver,",
              "the customer understands the risks involved,",
              "the customer accepts the risks voluntarily,",
              "the customer agrees to the limitation of liability,",
              "the customer agrees to be responsible for damages caused during the rental period.",
            ],
          },
          { type: "paragraph", text: "This agreement applies to all bookings and rentals with Wayli." },
        ],
      },
      {
        id: "minor-consent",
        iconKey: "minor",
        accent: "plum",
        title: "Minor Consent",
        eyebrow: "Consent requirements for participation by minors",
        blocks: [

          {
            type: "paragraph",
            text:
              "Participation of a minor in the SUP, canoe, or kayak rental requires the prior consent of a parent or other legal representative.",
          },
          { type: "heading", text: "Consent of the legal representative" },
          {
            type: "paragraph",
            text:
              "The legal representative consents to the minor's participation in the SUP, canoe, or kayak rental and to the use of the rented sports equipment by the minor.",
          },
          {
            type: "paragraph",
            text: "In doing so, the legal representative states that:",
          },
          {
            type: "list",
            items: [
              "the minor can swim sufficiently,",
              "no health limitations are known that would prevent participation,",
              "the minor has been informed about the safety rules,",
              "the instructions of the lessor must be followed.",
            ],
          },
          {
            type: "paragraph",
            text:
              "The legal representative acknowledges that the use of the sports equipment involves risks and takes place at the participant's own risk.",
          },
          { type: "heading", text: "Safety provisions" },
          {
            type: "paragraph",
            text:
              "The following safety obligations apply to the minor in particular:",
          },
          {
            type: "list",
            items: [
              "to wear buoyancy aids / life jackets (where prescribed),",
              "not to undertake trips during thunderstorms or strong wind,",
              "not to undertake trips under the influence of alcohol or drugs,",
              "to handle the rental equipment carefully,",
              "to follow the instructions of the lessor.",
            ],
          },
          { type: "heading", text: "Liability" },
          {
            type: "paragraph",
            text:
              "The legal representative is liable within the framework of the statutory provisions for culpably caused damage to the rental material by the minor.",
          },
          {
            type: "paragraph",
            text:
              "The lessor is liable exclusively for damage caused intentionally or by gross negligence, insofar as legally permissible.",
          },
          { type: "heading", text: "Consent to participation without accompaniment" },
          {
            type: "paragraph",
            text:
              "The legal representative may authorize the use of the rental equipment without the immediate accompaniment of an adult or may restrict use to participation only when accompanied by an adult.",
          },
          {
            type: "paragraph",
            text:
              "Where participation is permitted only with accompaniment, the accompanying person may be designated in advance.",
          },
        ],
      },
      {
        id: "handover",
        iconKey: "handover",
        accent: "sky",
        title: "Rental Agreement and Handover Protocol",
        eyebrow: "Operational handover and condition record",
        blocks: [
          {
            type: "paragraph",
            text:"At handover, the rental agreement records the rental item, the rental period, the agreed price, and any deposit. The renter acknowledges the proper handover of the rental item upon acceptance.",
          },
      
          { type: "heading", text: "Handover Protocol" },
          {
            type: "paragraph",
            text:
              "The handover protocol records the condition of the equipment at the time of handover.",
          },
          {
            type: "list",
            items: ["perfect condition", "slight signs of use", "damaged"],
          },
        ],
      },
    ],
  },
  de: {
    hero: {
      eyebrow: "Wayli Rechtsinformationen",
      title: "Rechtliche Informationen",
      description:
        "Diese Seite bündelt die bereitgestellten rechtlichen und operativen Texte für Wayli, einschließlich AGB, Datenschutz, Storno, Sicherheit, Minderjährigen-Einverständnis und Übergabeunterlagen.",
      navLabel: "Rechtliche Navigation",
    },
    highlights: [
      {
        accent: "reef",
        iconKey: "book",
        title: "Dokumentenbasierter Inhalt",
        description:
          "Die folgenden Rechtstexte folgen den bereitgestellten Dokumenten und ersetzen die bisherigen zusammengefassten Texte.",
      },
      {
        accent: "dawn",
        iconKey: "shield",
        title: "Deutsch + Englisch",
        description:
          "Die deutsche Fassung ist maßgeblich. Die englische Fassung ist eine automatische Übersetzung und dient nur der Information; bei Abweichungen gilt die deutsche Fassung.",
      },
      {
        accent: "lunar",
        iconKey: "refresh",
        title: "Erweiterte Dokumentabdeckung",
        description:
          "Die Seite deckt nun auch die Einverständniserklärung für Minderjährige und das Übergabeprotokoll ab.",
      },
    ],
    sections: [
      {
        id: "impressum",
        iconKey: "info",
        accent: "reef",
        title: "Impressum",
        eyebrow: "Informationen gemäß bereitgestelltem Dokument",
        blocks: [
          {
            type: "paragraph",
            text: "Information according to § 5 ECG, § 14 UGB, § 63 GewO and § 25 Mediengesetz",
          },
          {
            type: "meta",
            items: [
              { label: "Business Name", value: "Wayli" },
              { label: "Owner", value: "Andrii Lozovyi" },
              { label: "Business Form", value: "Einzelunternehmen (Sole Proprietorship)" },
              { label: "Business Address", value: "Dresdnerstrasse, 1200, Vienna, Austria" },
              { label: "Contact", value: "Email: wayli@wayli.eu" },
              { label: "ERJ", value: "9110038973861" },
              {
                label: "Business Activity",
                value:
                  "Rental of sports and leisure equipment, in particular stand-up paddle boards and kayaks.",
              },
              { label: "Gewerbebehörde", value: "Magistrat der Stadt Wien" },
              {
                label: "Applicable Legal Regulations",
                value: "Gewerbeordnung (GewO) Available at: www.ris.bka.gv.at",
              },
              { label: "Supervisory Authority", value: "Magistrat der Stadt Wien" },
              { label: "Responsible for Website Content", value: "Andrii Lozovyi" },
              {
                label: "Online Dispute Resolution",
                value:
                  "https://ec.europa.eu/consumers/odr/ We are not obliged or willing to participate in dispute resolution proceedings before a consumer arbitration board.",
              },
            ],
          },
        ],
      },
      {
        id: "terms",
        iconKey: "terms",
        accent: "dawn",
        title: "Allgemeine Geschäftsbedingungen",
        eyebrow: "SUP- und Kajakverleih Allgemeine Geschäftsbedingungen und Datenschutzerklärung",
        blocks: [
          { type: "heading", text: "1. Geltungsbereich" },
          {
            type: "paragraph",
            text:
              "Diese Allgemeinen Geschäftsbedingungen gelten für sämtliche Mietverträge zwischen dem Verleihunternehmen und dem Kunden betreffend die Vermietung von Stand-Up-Paddle-Boards (SUP), Kanus, Kajaks und Zubehör.",
          },
          { type: "heading", text: "2. Vertragsabschluss" },
          {
            type: "paragraph",
            text:
              "Der Mietvertrag kommt durch Reservierung und Bestätigung bzw. durch Übergabe der Mietgegenstände zustande.",
          },
          { type: "heading", text: "3. Mietdauer und Preise" },
          {
            type: "paragraph",
            text: "Die Mietdauer richtet sich nach der vereinbarten Buchung.",
          },
          {
            type: "paragraph",
            text: "Es gelten die zum Zeitpunkt der Buchung veröffentlichten Preise.",
          },
          {
            type: "paragraph",
            text: "Eine verspätete Rückgabe kann zusätzlich verrechnet werden.",
          },
          { type: "heading", text: "4. Benutzung der Mietgegenstände" },
          { type: "paragraph", text: "Der Kunde verpflichtet sich:" },
          {
            type: "list",
            items: [
              "die Mietgegenstände sachgemäß zu verwenden,",
              "Sicherheitsanweisungen einzuhalten,",
              "nur geeignete Gewässer zu befahren,",
              "keine Fahrten unter Alkohol- oder Drogeneinfluss durchzuführen,",
              "Schwimmkenntnisse zu besitzen.",
            ],
          },
          {
            type: "paragraph",
            text: "Kinder dürfen die Mietgegenstände nur unter Aufsicht Erwachsener benutzen.",
          },
          { type: "heading", text: "5. Haftung des Kunden" },
          {
            type: "paragraph",
            text:
              "Der Kunde haftet für Schäden, Verlust oder Diebstahl der Mietgegenstände, soweit diese durch unsachgemäße Verwendung oder schuldhaftes Verhalten verursacht wurden.",
          },
          { type: "paragraph", text: "Beschädigungen sind unverzüglich zu melden." },
          { type: "heading", text: "6. Haftung des Verleihers" },
          {
            type: "paragraph",
            text: "Die Benutzung erfolgt auf eigene Gefahr.",
          },
          {
            type: "paragraph",
            text:
              "Der Verleiher haftet nur für Schäden, die vorsätzlich oder grob fahrlässig verursacht wurden, soweit gesetzlich zulässig.",
          },
          { type: "paragraph", text: "Für persönliche Gegenstände wird keine Haftung übernommen." },
          { type: "heading", text: "7. Wetter und Sicherheit" },
          {
            type: "paragraph",
            text:
              "Bei gefährlichen Wetterbedingungen (Gewitter, Sturm etc.) kann die Vermietung aus Sicherheitsgründen verweigert oder beendet werden.",
          },
          {
            type: "paragraph",
            text:
              "Bereits bezahlte Beträge werden in diesem Fall anteilig rückerstattet oder gutgeschrieben.",
          },
          { type: "heading", text: "8. Rückgabe" },
          {
            type: "paragraph",
            text:
              "Die Mietgegenstände sind vollständig und in ordnungsgemäßem Zustand zurückzugeben.",
          },
          {
            type: "paragraph",
            text:
              "Bei außergewöhnlicher Verschmutzung kann eine Reinigungspauschale verrechnet werden.",
          },
          { type: "heading", text: "9. Gerichtsstand und anwendbares Recht" },
          {
            type: "paragraph",
            text: "Es gilt österreichisches Recht.",
          },
          {
            type: "paragraph",
            text: "Gerichtsstand ist der Sitz des Unternehmens.",
          },
        ],
      },
      {
        id: "cancellation",
        iconKey: "refresh",
        accent: "coral",
        title: "Rücktritts- und Stornobedingungen",
        eyebrow: "Rücktritts- und Stornobedingungen",
        blocks: [
          { type: "heading", text: "Rücktritts- und Stornobedingungen" },
          { type: "paragraph", text: "Stornierung durch den Kunden" },
          {
            type: "list",
            items: [
              "bis 24 Stunden vor Mietbeginn: kostenlose Stornierung oder Erstellung eines neuen Termins innerhalbderselben Mietsaison",
              "ab 24 Stunden vor Mietbeginn: 50 % Stornogebühr",
              "weniger als 24 Stunden bzw. am selben Tag des Mietbeginns oder Nichterscheinen: 100 % des Mietpreises",
            ],
          },
          { type: "paragraph", text: "Wetterbedingte Absage" },
          {
            type: "paragraph",
            text:
              "Bei Unwetter oder behördlichen Sperren kann die Buchung kostenlos verschoben oder rückerstattet werden.",
          },
          { type: "paragraph", text: "Vorzeitige Rückgabe" },
          {
            type: "paragraph",
            text:
              "Eine vorzeitige Rückgabe berechtigt grundsätzlich nicht zur Rückerstattung.",
          },
        ],
      },
      {
        id: "privacy",
        iconKey: "privacy",
        accent: "mint",
        title: "Datenschutzerklärung",
        eyebrow: "9. Datenschutzerklärung (DSGVO Österreich/EU)",
        blocks: [
          { type: "heading", text: "9. Datenschutzerklärung (DSGVO Österreich/EU)" },
          { type: "paragraph", text: "Verantwortlicher" },
          {
            type: "paragraph",
            text:
              "Wayli Verantwortliche Person: Hr. Andrii Lozovyi, Dresdnerstrasse 62, 1200 Wien, Österreich, E-Mail: wayli@wayli.eu",
          },
          { type: "paragraph", text: "Verarbeitung personenbezogener Daten" },
          {
            type: "paragraph",
            text: "Wir verarbeiten personenbezogene Daten ausschließlich zur:",
          },
          {
            type: "list",
            items: [
              "Bearbeitung von Buchungen,",
              "Durchführung des Mietvertrages,",
              "Kundenkommunikation,",
              "Rechnungslegung,",
              "Erfüllung gesetzlicher Verpflichtungen.",
            ],
          },
          { type: "paragraph", text: "Verarbeitete Daten" },
          {
            type: "paragraph",
            text: "Folgende Daten können verarbeitet werden:",
          },
          {
            type: "list",
            items: ["Name", "Telefonnummer", "E-Mail-Adresse", "Rechnungsadresse", "Buchungsdaten"],
          },
          { type: "paragraph", text: "Rechtsgrundlagen" },
          {
            type: "paragraph",
            text: "Die Verarbeitung erfolgt gemäß Art. 6 DSGVO:",
          },
          {
            type: "list",
            items: [
              "zur Vertragserfüllung,",
              "zur Erfüllung gesetzlicher Pflichten,",
              "aufgrund berechtigter Interessen.",
            ],
          },
          { type: "paragraph", text: "Speicherdauer" },
          {
            type: "paragraph",
            text:
              "Personenbezogene Daten werden nur so lange gespeichert, wie dies gesetzlich erforderlich oder für die Vertragsabwicklung notwendig ist.",
          },
          { type: "paragraph", text: "Weitergabe von Daten" },
          {
            type: "paragraph",
            text: "Eine Weitergabe erfolgt nur:",
          },
          {
            type: "list",
            items: [
              "an Steuerberater/Buchhaltung,",
              "Zahlungsdienstleister,",
              "IT-Dienstleister,",
              "soweit gesetzlich vorgeschrieben.",
            ],
          },
          { type: "paragraph", text: "Rechte der Betroffenen" },
          {
            type: "paragraph",
            text: "Kunden haben das Recht auf:",
          },
          {
            type: "list",
            items: [
              "Auskunft,",
              "Berichtigung,",
              "Löschung,",
              "Einschränkung der Verarbeitung,",
              "Datenübertragbarkeit,",
              "Widerspruch.",
            ],
          },
          {
            type: "paragraph",
            text: "Beschwerden können bei der österreichischen Datenschutzbehörde eingebracht werden.",
          },
        ],
      },
      {
        id: "liability",
        iconKey: "risk",
        accent: "lunar",
        title: "Haftungsausschluss und Sicherheitsbelehrung",
        eyebrow: "SUP- und Kajakverleih Haftungsausschluss und Sicherheitsbelehrung",
        blocks: [

          { type: "heading", text: "Sicherheitsbelehrung" },
          {
            type: "paragraph",
            text:
              "Für die Nutzung des Mietgerätes gelten auf Kundenseite folgende Voraussetzungen:",
          },
          {
            type: "list",
            items: [
              "über ausreichende Schwimmkenntnisse zu verfügen,",
              "körperlich in der Lage zu sein, die Aktivität sicher auszuüben,",
              "die Sicherheitsanweisungen verstanden zu haben,",
              "die Mietgeräte eigenverantwortlich zu benutzen.",
            ],
          },
          { type: "heading", text: "Sicherheitsregeln" },
          {
            type: "list",
            items: [
              "Das Tragen einer Schwimmhilfe wird ausdrücklich empfohlen bzw. bei Kindern verpflichtend vorgeschrieben.",
              "Die Benutzung der Mietgeräte unter Alkohol-, Drogen- oder Medikamenteneinfluss ist verboten.",
              "Gewässer, Wetterbedingungen und Schiffsverkehr sind laufend zu beachten.",
              "Bei Gewitter, Sturm, starkem Wind oder sonstigen Gefahrensituationen ist das Gewässer unverzüglich zu verlassen.",
              "Kinder und Jugendliche unter 18 Jahren dürfen Mietgeräte nur unter Aufsicht eines Erwachsenen benutzen bzw. mit schriftlicher Zustimmung eines Erziehungsberechtigten.",
              "Das Befahren gesperrter Bereiche oder Naturschutzflächen ist untersagt.",
              "Wertgegenstände dürfen nur auf eigene Gefahr mitgeführt werden.",
              "Der Kunde verpflichtet sich, das Mietgerät pfleglich zu behandeln und Schäden sofort zu melden.",
            ],
          },
          { type: "heading", text: "Haftungsausschluss" },
          {
            type: "paragraph",
            text:
              "Die Benutzung der gemieteten SUP-Boards, Kanus, Kajaks und Zubehörteile erfolgt auf eigene Gefahr.",
          },
          {
            type: "paragraph",
            text:
              "Der Vermieter haftet – soweit gesetzlich zulässig – ausschließlich für Schäden, die vorsätzlich oder grob fahrlässig verursacht wurden.",
          },
          {
            type: "paragraph",
            text: "Keine Haftung wird insbesondere übernommen für:",
          },
          {
            type: "list",
            items: [
              "Unfälle infolge unsachgemäßer Benutzung,",
              "Eigenverschulden des Kunden,",
              "Missachtung von Sicherheitsanweisungen,",
              "Schäden durch Wetter, Wellengang oder Naturereignisse,",
              "Verlust oder Beschädigung persönlicher Gegenstände,",
              "Verletzungen aufgrund mangelnder Schwimmkenntnisse.",
            ],
          },
          {
            type: "paragraph",
            text: "Der Kunde haftet für sämtliche durch ihn verursachten Schäden am Mietmaterial.",
          },
          {
            type: "paragraph",
            text:
              "Bei Verlust oder mutwilliger Beschädigung kann der Wiederbeschaffungswert verrechnet werden.",
          },
          { type: "heading", text: "Bestätigung des Kunden" },
          {
            type: "paragraph",
            text:
              "Mit der Buchung, Nutzung oder Übernahme der Mietgeräte gelten folgende Erklärungen und Pflichten des Kunden:",
          },
          {
            type: "list",
            items: [
              "die Sicherheitsbelehrung gelesen und verstanden zu haben,",
              "über ausreichende Schwimmkenntnisse zu verfügen,",
              "die Mietgeräte auf eigene Gefahr zu benutzen,",
              "den Anweisungen des Vermieters Folge zu leisten.",
            ],
          },
        ],
      },
      {
        id: "minor-consent",
        iconKey: "minor",
        accent: "plum",
        title: "Einverständnis für Minderjährige",
        eyebrow: "Vorgaben zur Teilnahme Minderjähriger",
        blocks: [
          {
            type: "paragraph",
            text:
              "Die Teilnahme eines Minderjährigen am SUP-, Kanu- oder Kajakverleih setzt die vorherige Zustimmung eines Erziehungsberechtigten oder sonstigen gesetzlichen Vertreters voraus.",
          },
          { type: "heading", text: "Zustimmung des gesetzlichen Vertreters" },
          {
            type: "paragraph",
            text:
              "Der gesetzliche Vertreter erklärt sich mit der Teilnahme des Minderjährigen am SUP-, Kanu- bzw. Kajakverleih sowie mit der Benutzung der gemieteten Sportgeräte durch den Minderjährigen einverstanden.",
          },
          {
            type: "paragraph",
            text: "Dabei erklärt der gesetzliche Vertreter, dass:",
          },
          {
            type: "list",
            items: [
              "der Minderjährige ausreichend schwimmen kann,",
              "keine gesundheitlichen Einschränkungen bekannt sind, die einer Teilnahme entgegenstehen,",
              "der Minderjährige über die Sicherheitsregeln informiert wurde,",
              "den Anweisungen des Vermieters Folge zu leisten ist.",
            ],
          },
          {
            type: "paragraph",
            text:
              "Dem gesetzlichen Vertreter ist bekannt, dass die Benutzung der Sportgeräte mit Risiken verbunden ist und auf eigene Gefahr erfolgt.",
          },
          { type: "heading", text: "Sicherheitsbestimmungen" },
          {
            type: "paragraph",
            text:
              "Für den Minderjährigen gelten insbesondere folgende Sicherheitsbestimmungen:",
          },
          {
            type: "list",
            items: [
              "Schwimmhilfen/Rettungswesten zu tragen (soweit vorgeschrieben),",
              "keine Fahrten bei Gewitter oder starkem Wind durchzuführen,",
              "keine Fahrten unter Alkohol- oder Drogeneinfluss vorzunehmen,",
              "die Mietgeräte sorgsam zu behandeln,",
              "den Anweisungen des Vermieters Folge zu leisten.",
            ],
          },
          { type: "heading", text: "Haftung" },
          {
            type: "paragraph",
            text:
              "Der gesetzliche Vertreter haftet im Rahmen der gesetzlichen Bestimmungen für schuldhaft verursachte Schäden am Mietmaterial durch den Minderjährigen.",
          },
          {
            type: "paragraph",
            text:
              "Der Vermieter haftet ausschließlich für vorsätzlich oder grob fahrlässig verursachte Schäden, soweit gesetzlich zulässig.",
          },
          { type: "heading", text: "Zustimmung zur Teilnahme ohne Begleitung" },
          {
            type: "paragraph",
            text:
              "Der gesetzliche Vertreter kann die Benutzung des Mietgeräts ohne unmittelbare Begleitung eines Erwachsenen zulassen oder die Teilnahme auf eine Benutzung in Begleitung eines Erwachsenen beschränken.",
          },
          {
            type: "paragraph",
            text:
              "Soweit eine Teilnahme nur mit Begleitung zulässig ist, kann die Begleitperson vorab benannt werden.",
          },
        ],
      },
      {
        id: "handover",
        iconKey: "handover",
        accent: "sky",
        title: "Mietvertrag und Übergabeprotokoll",
        eyebrow: "Regelungen zur Übergabe und Zustandsdokumentation",
        blocks: [
          { type: "heading", text: "Mietvertrag" },
          {
            type: "paragraph",
            text:
              "Bei der Übergabe werden im Mietvertrag der Mietgegenstand, die Mietdauer, der vereinbarte Preis sowie eine etwaige Kaution festgehalten.",
          },
          {
            type: "paragraph",
            text:
              "Mit der Übernahme erkennt der Mieter die ordnungsgemäße Übergabe des Mietgegenstandes an.",
          },
          { type: "heading", text: "Übergabeprotokoll" },
          {
            type: "paragraph",
            text:
              "Im Übergabeprotokoll wird der Zustand des Gerätes zum Zeitpunkt der Übergabe dokumentiert.",
          },
          {
            type: "list",
            items: ["einwandfrei", "leichte Gebrauchsspuren", "beschädigt"],
          },
        ],
      },
    ],
  },
};
